import axios from "axios";
import { ThemesContainerSingleton } from "@/banner_template/themes/ThemesContainerSinglton";

async function getPreviewData(commonRequestData, onlyRequestedInstances = []) {
  const includePagination =
    commonRequestData.includePagination && !(onlyRequestedInstances?.length);

  return axios.get(
    `/banner/${commonRequestData.customerId}/group/${commonRequestData.layoutId}/preview`,
    {
      params: {
        projectSearchQuery: commonRequestData.projectSearchQuery,
        selectedTemplates: commonRequestData.selectedTemplates,
        instance_id: commonRequestData.instanceId,
        templatesIds: commonRequestData.templatesIds ?? null,
      },
    }
  );
}

async function getDataLayoutsByIds(layoutsIds = [], customerId) {
  const layoutsData = {
    instances: [],
    settings: [],
    themeFonts: [],
    shadows: [],
  };

  const promises = layoutsIds.map(layoutId =>
    axios
      .get(`/banner/${customerId}/group/${layoutId}/preview`)
      .then(({ data }) => {
        for (const key in layoutsData) {
          layoutsData[key] = [...data[key], ...layoutsData[key]];
        }
      })
      .catch(err => {
        console.error("Layout fetch error:", err);
      })
  );

  await Promise.all(promises);
  return layoutsData;
}

export default {
  namespaced: true,

  state: () => ({
    templates: [],
    layouts: {},
    options: {},
    loading: false,
    error: null,
    pagination: {
      page: 1,
      perPage: 10,
      totalPages: 1,
    },
  }),

  getters: {
    templates: state => state.templates,
    hasData: state => state.templates.length > 0,
    loading: state => state.loading,
    options: state => state.options,
  },

  mutations: {
    SET_TEMPLATES(state, templates) {
      state.templates = templates;
    },
    SET_LAYOUTS(state, layouts) {
      state.layouts = layouts;
    },
    SET_OPTIONS(state, options) {
      state.options = options;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_PAGINATION(state, pagination) {
      state.pagination = { ...state.pagination, ...pagination };
    },
  },

  actions: {
    async fetchTemplates({ commit }, {
      customerId,
      layoutId,
      page = 1,
      perPage = 10,
      versionId = null,
      selectedTemplates = null,
      projectSearchQuery = null,
      includePagination = true,
      paginationLastPage = null,
    }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);

      try {
        const { data } = await getPreviewData(
          {
            customerId,
            layoutId,
            page,
            perPage,
            versionId,
            selectedTemplates,
            projectSearchQuery,
            includePagination,
            paginationLastPage,
          },
          []
        );
        commit("SET_TEMPLATES", data.instances || []);
        commit("SET_OPTIONS", data.options || {});
        commit("SET_PAGINATION", { totalPages: data.lastPage || 1 });

        ThemesContainerSingleton.load(
          (data.instances || []).flatMap(instance => instance.themeIds || [])
        );
        await ThemesContainerSingleton.waitAll();

        if (data?.options?.layouts?.length) {
          const layouts = await getDataLayoutsByIds(
            data.options.layouts,
            customerId
          );
          commit("SET_LAYOUTS", layouts);
        }

        return data;
      } catch (err) {
        console.error("fetchTemplates error:", err);
        commit("SET_ERROR", err);
        throw err;
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
};
